/* =======================================================
   Gallery & YouTube controller for C01 Page
   Developed by 8 Dotz Design LLC
   Date: 2025-09-17
   ======================================================= */

(() => {
  if (window.__PAGE_C01_GALLERY_LOADED__) return;
  window.__PAGE_C01_GALLERY_LOADED__ = true;

  function collectTargets(scope = document) {
    const list = [];
    const oldGal = scope.querySelector('#page_c01_gallery');
    if (oldGal) list.push({ root: oldGal, type: 'gal' });
    const oldYt = scope.querySelector('#page_c01_yt3');
    if (oldYt) list.push({ root: oldYt, type: 'yt' });
    scope.querySelectorAll('[id^="page_c01_gallery-"]').forEach(el => {
      if (el.id !== 'page_c01_gallery') list.push({ root: el, type: 'gal' });
    });
    return list;
  }

  collectTargets().forEach(({ root, type }) => setup(root, type));
  document.addEventListener('shopify:section:load', e => {
    collectTargets(e.target).forEach(({ root, type }) => setup(root, type));
  });
  document.addEventListener('shopify:section:reorder', e => {
    collectTargets(e.target).forEach(({ root, type }) => setup(root, type));
  });

  function setup(root, type){
    if (root.hasAttribute('data-c01-inited')) return;

    const q   = (sel) => root.querySelector(sel);
    const vp  = q(type==='yt' ? '.page_c01_yt3__viewport'  : '.page_c01_gallery__viewport');
    const tr  = q(type==='yt' ? '.page_c01_yt3__track'     : '.page_c01_gallery__track');
    const prev= q(type==='yt' ? '.page_c01_yt3__btn--prev' : '.page_c01_gallery__btn--prev');
    const next= q(type==='yt' ? '.page_c01_yt3__btn--next' : '.page_c01_gallery__btn--next');
    if (!vp || !tr || !prev || !next) return;

    const isMobileYT  = () => window.innerWidth <= 1023;
    const isMobileGal = () => window.innerWidth <= 600;
    const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
    const getWidth = (el) => el.clientWidth || el.getBoundingClientRect().width || 0;

    let pageEls = [];
    let raw = [];
    let idx = 0;
    let w = 0;
    let dragging = false, sx = 0, cx = 0;
    let prevPer = (type==='gal' && isMobileGal()) ? 1 : 2;

    if (type === 'yt') {
      pageEls = Array.from(tr.querySelectorAll('.page_c01_yt3__page'));
      if (!pageEls.length) { root.style.display = 'none'; return; }
    } else {
      raw = Array.from(tr.querySelectorAll('.page_c01_gallery__item'));
      if (!raw.length) { root.style.display = 'none'; return; }
    }

    function setGalleryMode(){
      if (type !== 'gal') return;
      const per = isMobileGal() ? 1 : 2;
      root.classList.toggle('is-single', per === 1);
      root.classList.toggle('is-double', per !== 1);
    }

    function regroupGallery(keepFirstIndex = 0){
      if (type !== 'gal') return;
      const per = isMobileGal() ? 1 : 2;
      tr.innerHTML = '';
      pageEls = [];
      for (let i = 0; i < raw.length; i += per) {
        const p = document.createElement('div');
        p.className = 'page_c01_gallery__page';
        for (let j = 0; j < per && i + j < raw.length; j++) p.appendChild(raw[i + j]);
        tr.appendChild(p);
        pageEls.push(p);
      }
      idx = clamp(Math.floor(keepFirstIndex / per), 0, pageEls.length - 1);
      prevPer = per;
    }

    const pages = () => pageEls.length;
    const snap  = () => { tr.style.transform = `translate3d(${-idx * w}px,0,0)`; };

    function updateButtons(){
      if (pages() <= 1) { prev.disabled = true; next.disabled = true; return; }
      if (type === 'yt' && !isMobileYT()) { prev.disabled = true; next.disabled = true; return; }
      prev.disabled = (idx === 0);
      next.disabled = (idx === pages() - 1);
    }

    function resize(){
      const widthCandidate = getWidth(vp);
      if (!widthCandidate) { requestAnimationFrame(resize); return; }
      w = widthCandidate;

      if (type === 'gal') {
        setGalleryMode();
        const keep = idx * prevPer;
        regroupGallery(keep);
        tr.style.transition = 'transform .35s ease';
        snap();
      } else {
        if (isMobileYT()) {
          idx = clamp(idx, 0, pages() - 1);
          tr.style.transition = 'transform .35s ease';
          snap();
        } else {
          idx = 0;
          tr.style.transition = 'none';
          tr.style.transform  = 'none';
        }
      }
      updateButtons();
    }

    function to(i){
      if (pages() <= 1) return;
      if (type === 'yt' && !isMobileYT()) return;
      idx = clamp(i, 0, pages() - 1);
      snap(); updateButtons();
    }
    prev.addEventListener('click', () => to(idx - 1));
    next.addEventListener('click', () => to(idx + 1));

    function onDown(e){
      if (type === 'yt' && !isMobileYT()) return;
      dragging = true; sx = cx = e.clientX;
      tr.style.transition = 'none';
      if (vp.setPointerCapture) { try { vp.setPointerCapture(e.pointerId); } catch(_){} }
    }
    function onMove(e){
      if (!dragging) return;
      cx = e.clientX;
      const dx = cx - sx;
      const base = -idx * w;
      tr.style.transform = `translate3d(${base + dx}px,0,0)`;
      e.preventDefault();
    }
    function onUp(){
      if (!dragging) return;
      dragging = false;
      const dx = cx - sx;
      tr.style.transition = 'transform .35s ease';
      const th = Math.max(40, w * 0.15);
      if (dx >  th) to(idx - 1);
      else if (dx < -th) to(idx + 1);
      else snap();
    }
    vp.addEventListener('pointerdown',  onDown, { passive:true  });
    vp.addEventListener('pointermove',  onMove,  { passive:false });
    vp.addEventListener('pointerup',    onUp,    { passive:true  });
    vp.addEventListener('pointercancel',onUp,    { passive:true  });
    vp.addEventListener('pointerleave', onUp,    { passive:true  });

    if (type === 'gal') { setGalleryMode(); regroupGallery(0); }
    resize();
    window.addEventListener('resize', resize, { passive:true });
    document.addEventListener('visibilitychange', () => { if (!document.hidden) resize(); });

    root.setAttribute('data-c01-inited', '1');
  }
})();
